import { createSelector } from 'reselect'
import _ from 'lodash'

export default (key, type) =>
  createSelector(state => {
    const json = _.get(state, `${key}.error`, {})
    const details = _.get(json, 'error.details', {})
    return type ? (type === _.get(json, 'error.type') ? details : {}) : details
  }, _.identity)



// WEBPACK FOOTER //
// ./src/selectors/errors.js